/* eslint-disable default-case */
// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { BiCategoryAlt } from "react-icons/bi";
// import { IoSearchOutline } from "react-icons/io5";
// import { MdOutlineAccountCircle } from "react-icons/md";
// import { FaShoppingCart } from "react-icons/fa";
// import { IoHome } from "react-icons/io5";
// const Checkout = () => {
//   const navigate = useNavigate();
//   const [cartItems, setCartItems] = useState([]);
//   const [formData, setFormData] = useState({
//     firstName: '',
//     lastName: '',
//     email: '',
//     mobile: '',
//     flatHouseNo: '',
//     landmark: '',
//     city: '',
//     pinCode: '',
//     orderNotes: '',
//     aadharNumber: '',
//     deliveryType: 'instore' // Add a new state for delivery type
//   });


//   const [deliveryCharge, setDeliveryCharge] = useState(0);
//   const [isPaymentEnabled, setIsPaymentEnabled] = useState(false);
//   useEffect(() => {
//     const storedCartItems = JSON.parse(localStorage.getItem('cartItems') || '[]');
//     setCartItems(storedCartItems);
    
//     const phoneNumber = localStorage.getItem('phoneNumber');
//     if (phoneNumber) {
//       setFormData(prev => ({ ...prev, mobile: phoneNumber }));
//     }
//   }, []);
//   console.log("localcart",cartItems)

//   const validateForm = () => {
//     const newErrors = {};
    
//     // Name validation (only alphabets and spaces)
//     if (!formData.firstName.trim()) {
//       newErrors.firstName = "First Name is required.";
//     } else if (!/^[A-Za-z\s]+$/.test(formData.firstName)) {
//       newErrors.firstName = "First Name should only contain alphabets.";
//     }
  
//     if (formData.lastName && !/^[A-Za-z\s]*$/.test(formData.lastName)) {
//       newErrors.lastName = "Last Name should only contain alphabets.";
//     }
  
//     // Aadhar number validation (exactly 12 digits)
//     if (!formData.aadharNumber.trim()) {
//       newErrors.aadharNumber = "Aadhar Card Number is required.";
//     } else if (!/^\d{12}$/.test(formData.aadharNumber)) {
//       newErrors.aadharNumber = "Aadhar Card Number must be exactly 12 digits.";
//     }
  
//     // Email validation
//     if (!formData.email.trim()) {
//       newErrors.email = "Email ID is required.";
//     } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)) {
//       newErrors.email = "Please enter a valid email address.";
//     }
  
//     // Mobile number validation (exactly 10 digits)
//     if (!formData.mobile.trim()) {
//       newErrors.mobile = "Mobile Number is required.";
//     } else if (!/^\d{10}$/.test(formData.mobile)) {
//       newErrors.mobile = "Mobile Number must be exactly 10 digits.";
//     }
  
//     // If delivery type is door delivery, validate address fields
//     if (formData.deliveryType === 'doordelivery') {
//       if (!formData.flatHouseNo.trim()) {
//         newErrors.flatHouseNo = "Flat/House No. is required for door delivery.";
//       }
//       if (!formData.landmark.trim()) {
//         newErrors.landmark = "Landmark is required for door delivery.";
//       }
//       if (!formData.city.trim()) {
//         newErrors.city = "City is required for door delivery.";
//       }
//       if (!formData.pinCode.trim()) {
//         newErrors.pinCode = "Pin Code is required for door delivery.";
//       } else if (!/^\d{6}$/.test(formData.pinCode)) {
//         newErrors.pinCode = "Pin Code must be exactly 6 digits.";
//       }
//     }
  
//     setErrors(newErrors);
//     setIsPaymentEnabled(Object.keys(newErrors).length === 0);
//     return Object.keys(newErrors).length === 0;
//   };
  
//   const [isAddressEnabled, setIsAddressEnabled] = useState(false);

// const handlePayment = async (e) => {
//     e.preventDefault();

//     const userId = localStorage.getItem('phoneNumber');
//     if (!userId) {
//       alert('Please login first');
//       navigate('/login');
//       return;
//     }

//     const amount = productPrice + securityDeposit + deliveryCharge
//     const paymentData = {
//       amount: amount,
//       firstname: formData.firstName,
//       email: formData.email,
//       phone: formData.mobile,
//       productinfo: cartItems[0]?.productName,

//     };
//     try {
//       console.log("Sending Payment Request:", paymentData);
//       const response = await axios.post("/initiate-payment", paymentData);
//       console.log("Payment Response:", response.data);

//       if (response.data) {
//         window.location.href =  `https://testpay.easebuzz.in/pay/${response.data.data}`; // ✅ Redirect to Easebuzz
//       } else {
//         console.error("🔴 Payment initiation failed");
//       }
//     } catch (error) {
//       console.error("🔴 Error initiating payment:", error.message);
//     }

//     // try {
//     //   const orderId = await fetchOrderId(amount);
//     //   if (!orderId) return;

//     //   const options = {
//     //     key: "rzp_live_muXPQqEDhWQ3jX",
//     //     amount: amount * 100,
//     //     currency: "INR",
//     //     name: "RoyalHood",
//     //     description: "Order Payment",
//     //     order_id: orderId,
//     //     image: "https://royalhood.in/favicon.ico",
//     //     handler: function (response) {
//     //       handlePaymentSuccess(response);
//     //     },
//     //     theme: {
//     //       color: "green",
//     //     },
//     //   };

//     //   const paymentObject = new window.Razorpay(options);
//     //   paymentObject.open();

//     //   paymentObject.on("payment.failed", (response) => {
//     //     console.error(response.error);
//     //     alert("Payment failed. Reason: " + response.error.reason);
//     //   });
//     // } catch (error) {
//     //   console.error("Payment initiation failed:", error);
//     //   alert("Failed to initiate payment. Please try again.");
//     // }
//   };
 
//   const [Paymentresponse, setPaymentResponse] = useState(null);
//   useEffect(() => {
//     axios
//       .get("/api/getpaymentresponse", { withCredentials: true })
//       .then(res => {
//         setPaymentResponse(res.data);
//         if (res.data && res.data.easepayid) {
//           handlePaymentSuccess(res.data.easepayid);
//         }
//       })
//       .catch(err => setPaymentResponse({ error: "Failed to fetch payment details" }),
//             console.error("Error fetching payment response:")  
//     );
//   }, []);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
  
//     // Update form data
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
  
//     // Update delivery charge and address fields enablement
//     if (name === 'deliveryType') {
//       const isDoorDelivery = value === 'doordelivery';
//       setDeliveryCharge(isDoorDelivery ? 500 : 0);
//       setIsAddressEnabled(isDoorDelivery);
//     }
  
//     // Clear error for the current field
//     setErrors(prev => {
//       const newErrors = { ...prev };
//       delete newErrors[name];
//       return newErrors;
//     });
  
//     // Perform real-time validation for specific fields
//     const fieldValidation = {};
//     switch (name) {
//       case 'firstName':
//         if (value && !/^[A-Za-z\s]+$/.test(value)) {
//           fieldValidation[name] = "First Name should only contain alphabets.";
//         }
//         break;
//       case 'lastName':
//         if (value && !/^[A-Za-z\s]*$/.test(value)) {
//           fieldValidation[name] = "Last Name should only contain alphabets.";
//         }
//         break;
//       case 'aadharNumber':
//         if (value && !/^\d*$/.test(value)) {
//           fieldValidation[name] = "Aadhar Card Number should only contain digits.";
//         } else if (value && value.length === 12 && !/^\d{12}$/.test(value)) {
//           fieldValidation[name] = "Aadhar Card Number must be exactly 12 digits.";
//         }
//         break;
//       case 'mobile':
//         if (value && !/^\d*$/.test(value)) {
//           fieldValidation[name] = "Mobile Number should only contain digits.";
//         } else if (value && value.length === 10 && !/^\d{10}$/.test(value)) {
//           fieldValidation[name] = "Mobile Number must be exactly 10 digits.";
//         }
//         break;
//       case 'email':
//         if (value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
//           fieldValidation[name] = "Please enter a valid email address.";
//         }
//         break;
//       case 'pinCode':
//         if (value && !/^\d*$/.test(value)) {
//           fieldValidation[name] = "Pin Code should only contain digits.";
//         } else if (value && value.length === 6 && !/^\d{6}$/.test(value)) {
//           fieldValidation[name] = "Pin Code must be exactly 6 digits.";
//         }
//         break;
//     }
//     validateFields(name, value);
  
//     setErrors(prev => ({
//       ...prev,
//       ...fieldValidation
//     }));
//     const hasErrors = Object.keys(fieldValidation).length > 0;
//     setIsPaymentEnabled(!hasErrors);
//   };
  
  
//   const validateFields = (fieldName, fieldValue) => {
//     const requiredFields = ['firstName', 'aadharNumber', 'email', 'mobile'];
//     const addressFields = ['flatHouseNo', 'landmark', 'city', 'pinCode'];

//     let allFieldsFilled = requiredFields.every(
//       (field) => (field === fieldName ? fieldValue.trim() : formData[field]?.trim()) !== ''
//     );

//     if (formData.deliveryType === 'doordelivery') {
//       allFieldsFilled =
//         allFieldsFilled &&
//         addressFields.every(
//           (field) => (field === fieldName ? fieldValue.trim() : formData[field]?.trim()) !== ''
//         );
//     }

//     setIsPaymentEnabled(allFieldsFilled);
//   };


//   const isAddressFieldsEnabled = formData.deliveryType === "doordelivery";









//   const [errors, setErrors] = useState({});

//   const calculateTotals = () => {
    
//     const cartItems = JSON.parse(localStorage.getItem('cartItems') || '[]');
//     const productPrice = cartItems.reduce((total, item) => total + parseFloat(item.salePrice), 0);
//     const securityDeposit = productPrice;

//     const total = productPrice + securityDeposit + deliveryCharge;

//     localStorage.setItem("total1", total);
//     console.log("total", total);

//     return {
//       productPrice,
//       securityDeposit,
//       total,
//       deliveryCharge
//     };
//   };

//   const generateOrderId = () => {
//     // Generate a unique order ID with prefix 'ORD' followed by timestamp and random number
//     const timestamp = new Date().getTime();
//     const random = Math.floor(Math.random() * 1000);
//     return `ORD${timestamp}${random}`;
//   };


//   const createOrderObject = (orderId, transactionId, paymentResponse, paymentStatus, orderStatus) => {
//     const { productPrice, securityDeposit, total } = calculateTotals();
//     const cartItems = JSON.parse(localStorage.getItem("cartItems") || "[]");    
//     return {
//       orderId,
//       orderDate: new Date().toISOString(),

//       customerId: localStorage.getItem("phoneNumber") || "unknown", // Ensure fallback value
//       customerDetails: {
//         firstName: formData.firstName,
//         lastName: formData.lastName,
//         email: formData.email,
//         mobile: formData.mobile,
//         aadharNumber: formData.aadharNumber,
//         deliveryType: formData.deliveryType,
//         address: {
//           flatHouseNo: formData.flatHouseNo,
//           landmark: formData.landmark,
//           city: formData.city,
//           pinCode: formData.pinCode,
//         },
//       },
//       orderNotes: formData.orderNotes || "",
//       products: cartItems.map((item) => ({
//         productId: item.id,
//         images: item.image,
//         duration: item.duration,
//         sizeId: item.sizeId,
//         name: item.productName,
//         price: parseFloat(item.salePrice),
//         quantity: item.quantity || 1,
//         deliveryDate: item.deliveryDate,
//         returnDate: item.returnDate,
//       })),
//       paymentDetails: {
//         productPrice,
//         securityDeposit,
//         totalAmount: total,
//         paymentId: transactionId,
//         status: paymentStatus,
//       },
//       orderStatus,
//       createdAt: new Date().toISOString(),
//       updatedAt: new Date().toISOString(),
//     };
//   };


//   const handlePaymentSuccess = async (paymentResponse) => {
//     try {
//       console.log('Payment Response:', paymentResponse);

//       // Retrieve transactionId from paymentResponse or localStorage
//       const transactionId = paymentResponse;
//       if (!transactionId) {
//         throw new Error('Transaction ID not found. Payment flow disrupted.');
//       }

//       // Generate orderId and proceed
//       const orderId = generateOrderId();
//       const paymentStatus = "completed";
//       const orderStatus = "confirmed";
//       const orderData = createOrderObject(orderId, transactionId, paymentResponse, paymentStatus, orderStatus);

//       // Save order and navigate
//       const savedOrder = await saveOrderToDatabase(orderData);
//       localStorage.removeItem('transactionId');
//       navigate('/OrderConfirm', { state: { orderId: savedOrder.orderId, totalAmount: orderData.paymentDetails.totalAmount, transactionId } });
//     } catch (error) {
//       alert('Failed to save order details. Please contact support.');
//       console.error('Order placement error:', error);
//     }
//   };

//   const saveOrderToDatabase = async (orderData) => {
//     try {
//       const response = await fetch('/api/orders', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Authorization': `Bearer ${localStorage.getItem('token')}`
//         },
//         body: JSON.stringify(orderData)
//       });

//       if (!response.ok) {
//         throw new Error('Failed to save order');
//       }

//       return await response.json();
//     } catch (error) {
//       console.error('Error saving order:', error);
//       throw error;
//     }
//   };



// const handleSubmit = async () => {
//     const userId = localStorage.getItem('phoneNumber');
    
//     // Validate the form
//     const errors = validateForm();
  
//     // If there are errors, show them and prevent form submission
//     if (Object.keys(errors).length > 0) {
//       console.log('Form has errors:', errors);
//       setErrors(errors);  // Assuming you have setErrors to show errors in the UI
//       return;  // Don't proceed further if there are errors
//     }
  
//     // Check if the user is logged in
//     if (!userId) {
//       alert('Please login first');
//       navigate('/login');
//       return;
//     }
  
//     // Proceed with form submission if there are no errors
//     console.log('Form is valid', formData);
  
//     try {
//       // Generate order ID
//       const orderId = generateOrderId();
  
//       // Create order object
//       const orderData = createOrderObject(orderId);
  
//       // Save to database
//       const savedOrder = await saveOrderToDatabase(orderData);
  
//       // Clear cart
//       localStorage.removeItem('cartItems');
  
//       // Navigate to confirmation page
//       navigate('/OrderConfirm', {
//         state: {
//           orderId: savedOrder.orderId,
//           totalAmount: orderData.paymentDetails.totalAmount
//         }
//       });
//     } catch (error) {
//       alert('Failed to place order. Please try again.');
//       console.error('Order placement error:', error);
//     }
//   };
  
//   const { productPrice, securityDeposit, total } = calculateTotals();



//   const amountInRupees = parseFloat(localStorage.getItem("total1"));
//   const amountInPaise = amountInRupees * 100; // Convert to paise (100 paise = 1 INR)

//   // const loadRazorpay = async () => {
//   //   try {
//   //     // Send a POST request to your backend /pay endpoint with the amount
//   //     const response = await axios.post('/pay', {
//   //       amount: amountInPaise,  // Send the amount to the backend
//   //     }, {
//   //       headers: {
//   //         'Content-Type': 'application/json',
//   //       },
//   //     });
//   //     const { redirectUrl, transactionId } = response.data;
//   //     handlePaymentSuccess(transactionId)
//   //     localStorage.setItem('transactionId', transactionId);
//   //     // Get the redirect URL from the response

//   //     // Redirect the user to the payment page
//   //     window.location.href = redirectUrl;
//   //   } catch (error) {
//   //     console.error('Error initiating payment:', error);
//   //     alert('Error initiating payment. Please try again later.');
//   //   }
//   // };

//   return (
//     <div className="checkout-container">
//       <style>
//         {`
//           .checkout-container {
//             max-width: 1200px;
//             margin: 0 auto;
//             padding: 20px;
//           }

//           .checkout-wrapper {
//             display: flex;
//             gap: 30px;
//             flex-direction: column;
//           }

//           @media (min-width: 768px) {
//             .checkout-wrapper {
//               flex-direction: row;
//             }
//           }

//           .delivery-form {
//             flex: 2;
//           }

//           .price-details {
//             flex: 1;
//           }

//           .form-title {
//             font-size: 24px;
//             font-weight: bold;
//             margin-bottom: 20px;
//           }

//           .form-grid {
//             display: grid;
//             grid-template-columns: 1fr;
//             gap: 15px;
//           }

//           @media (min-width: 768px) {
//             .form-grid-2 {
//               grid-template-columns: 1fr 1fr;
//             }
//           }

//           .form-group {
//             margin-bottom: 15px;
//           }

//           .form-label {
//             display: block;
//             font-size: 14px;
//             font-weight: 500;
//             margin-bottom: 5px;
//           }

//           .form-input {
//             width: 100%;
//             padding: 8px 12px;
//             border: 1px solid #ddd;
//             border-radius: 4px;
//             font-size: 14px;
//           }

//           .form-input:focus {
//             outline: none;
//             border-color: #666;
//           }

//           .form-input.readonly {
//             background-color: #f5f5f5;
//           }

//           .price-card {
//             background-color: #f8f8f8;
//             border-radius: 8px;
//             padding: 20px;
//           }

//           .price-title {
//             font-size: 18px;
//             font-weight: 600;
//             margin-bottom: 15px;
//           }

//           .price-row {
//             display: flex;
//             justify-content: space-between;
//             padding: 10px 0;
//             border-bottom: 1px solid #ddd;
//           }

//           .price-total {
//             display: flex;
//             justify-content: space-between;
//             padding: 15px 0;
//             font-weight: bold;
//             font-size: 18px;
//           }

//           .proceed-button {
//             width: 100%;
//             padding: 12px;
//             background-color: #ffc107;
//             border: none;
//             border-radius: 4px;
//             font-weight: 600;
//             cursor: pointer;
//             margin-top: 15px;
//           }

//           .proceed-button:hover {
//             background-color: #ffb300;
//           }

//           .note-box {
//             margin-top: 20px;
//             padding: 15px;
//             background-color: white;
//             border-radius: 4px;
//             box-shadow: 0 1px 3px rgba(0,0,0,0.1);
//           }

//           .note-title {
//             font-weight: 600;
//             margin-bottom: 8px;
//           }

//           .note-text {
//             font-size: 14px;
//             line-height: 1.4;
//           }

//           .form-textarea {
//             width: 100%;
//             padding: 8px 12px;
//             border: 1px solid #ddd;
//             border-radius: 4px;
//             min-height: 100px;
//             resize: vertical;
//           }
//         `}
//       </style>
//       <div className="checkout-wrapper">
//         {/* Left side - Delivery Details Form */}
//         <div className="delivery-form">
//           <h2 className="form-title">Delivery Details</h2>
//           <form onSubmit={handleSubmit}>
//             <div className="form-grid form-grid-2">
//               <div className="form-group">
//                 <label className="form-label">First Name</label>
//                 <input
//                   type="text"
//                   name="firstName"
//                   value={formData.firstName}
//                   onChange={handleInputChange}
//                   className="form-input"
//                   required
//                 />
//                 {errors.firstName && <span className="serror-message">{errors.firstName}</span>}
//               </div>
//               <div className="form-group">
//                 <label className="form-label">Last Name</label>
//                 <input
//                   type="text"
//                   name="lastName"
//                   value={formData.lastName}
//                   onChange={handleInputChange}
//                   className="form-input"
//                 />
//               </div>
//             </div>

//             <div className="form-group">
//               <label className="form-label">Aadhar Card Number</label>
//               <input
//                 type="tel"
//                 name="aadharNumber"
//                 value={formData.aadharNumber}
//                 onChange={handleInputChange}
//                 className="form-input"
//                 placeholder="Enter your 12-digit Aadhar number"
//                 maxLength="12"
//                 pattern="\d{12}"
//                 required
//               />
//               {errors.aadharNumber && <span className="serror-message">{errors.aadharNumber}</span>}
//             </div>

//             <div className="form-grid form-grid-2">
//               <div className="form-group">
//                 <label className="form-label">Email ID</label>
//                 <input
//                   type="email"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleInputChange}
//                   className="form-input"
//                   required
//                 />
//                 {errors.email && <span className="serror-message">{errors.email}</span>}
//               </div>
//               <div className="form-group">
//                 <label className="form-label">Mobile Number</label>
//                 <input
//                   type="tel"
//                   name="mobile"
//                   value={formData.mobile}
//                   onChange={handleInputChange}
//                   className="form-input"
//                   required
//                    maxLength="10"
//                 />
//                 {errors.mobile && <span className="serror-message">{errors.mobile}</span>}
//               </div>
//             </div>

//             <div className="form-group">
//               <label className="form-label">Delivery Type</label>
//               <select
//                 name="deliveryType"
//                 value={formData.deliveryType}
//                 onChange={handleInputChange}
//                 className="form-input"
//                 required
//               >
//                 <option value="instore">In-Store Pickup</option>
//                 <option value="doordelivery">Door Delivery</option>
//               </select>
//             </div>

//             {/* {isAddressFieldsEnabled && (
//             <>
//               <div className="form-group">
//                 <label className="form-label">Flat, House no.</label>
//                 <input
//                   type="text"
//                   name="flatHouseNo"
//                   value={formData.flatHouseNo}
//                   onChange={handleInputChange}
//                   className="form-input"
//                   placeholder="Flat, House no., Building, Company, Apartment"
//                   required
//                 />
//               </div>
//               <div className="form-group">
//                 <label className="form-label">Landmark</label>
//                 <input
//                   type="text"
//                   name="landmark"
//                   value={formData.landmark}
//                   onChange={handleInputChange}
//                   className="form-input"
//                   placeholder="Area, Street, Sector, Village"
//                   required
//                 />
//               </div>
//               <div className="form-grid form-grid-2">
//                 <div className="form-group">
//                   <label className="form-label">City</label>
//                   <input
//                     type="text"
//                     name="city"
//                     value={formData.city}
//                     onChange={handleInputChange}
//                     className="form-input"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label className="form-label">Pincode</label>
//                   <input
//                     type="text"
//                     name="pinCode"
//                     value={formData.pinCode}
//                     onChange={handleInputChange}
//                     className="form-input"
//                     required
//                   />
//                 </div>
//               </div>
//             </>
//           )} */}

//             {isAddressEnabled && (
//               <>
//                 <div className="form-group">
//                   <label className="form-label">Flat, House no.</label>
//                   <input
//                     type="text"
//                     name="flatHouseNo"
//                     value={formData.flatHouseNo}
//                     onChange={handleInputChange}
//                     className="form-input"
//                     placeholder="Flat, House no., Building, Company, Apartment"
//                     required
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label className="form-label">Landmark</label>
//                   <input
//                     type="text"
//                     name="landmark"
//                     value={formData.landmark}
//                     onChange={handleInputChange}
//                     className="form-input"
//                     placeholder="Area, Street, Sector, Village"
//                     required
//                   />
//                 </div>
//                 <div className="form-grid form-grid-2">
//                   <div className="form-group">
//                     <label className="form-label">City</label>
//                     <input
//                       type="text"
//                       name="city"
//                       value={formData.city}
//                       onChange={handleInputChange}
//                       className="form-input"
//                       required
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label className="form-label">Pincode</label>
//                     <input
//                       type="text"
//                       name="pinCode"
//                       value={formData.pinCode}
//                       onChange={handleInputChange}
//                       className="form-input"
//                       required
//                     />
//                   </div>
//                 </div>
//               </>
//             )}


//             <div className="form-group">
//               <label className="form-label">Order Notes (Optional)</label>
//               <textarea
//                 name="orderNotes"
//                 value={formData.orderNotes}
//                 onChange={handleInputChange}
//                 className="form-textarea"
//                 rows="4"
//               />
//             </div>
//           </form>
//         </div>

//         {/* Right side - Price Details */}
//         <div className="price-details">
//           <div className="price-card">
//             <h3 className="price-title">Price Details</h3>
//             <div className="price-row">
//               <span>Products Price</span>
//               <span>₹{productPrice.toFixed(2)}</span>
//             </div>
//             <div className="price-row">
//               <span>Refundable Security Deposit</span>
//               <span>₹{securityDeposit.toFixed(2)}</span>
//             </div>
//             <div className="price-row">
//               <span>Delivery Charge</span>
//               <span>₹{deliveryCharge.toFixed(2)}</span>
//             </div>
//             <div className="price-total">
//               <span>Total Amount</span>
//               <span>₹{(productPrice + securityDeposit + deliveryCharge).toFixed(2)}</span>

//             </div>
//             <button
//               type="button"
//               onClick={handlePayment}
//               className="proceed-button"
//               disabled={!isPaymentEnabled}
//             >
//               PROCEED PAYMENT
//             </button>
//           </div>

//           <div className="note-box">
//             <h4 className="note-title">NOTE</h4>
//             <p className="note-text">
//               Please visit the nearest showroom in <strong>RoyalHood #29, 1st Floor, BTM 2nd Stage, Bannerghatta Main Road, Opposite To Gopalan Mall, Next Jayadeva Metro Station, Bangalore - 560076 </strong> to
//               give fittings for the final booking.
//             </p>
//           </div>
//         </div>
//       </div>
//       <div class="tf-toolbar-bottom type-1150">
//         <div class="toolbar-item">
//           <a style={{ color: "black" }} href="/">
//             <div class="toolbar-icon">
//               <IoHome />
//             </div>
//             <div class="toolbar-label">Home</div>
//           </a>
//         </div>
//         <div class="toolbar-item">
//           <a style={{ color: "black" }} href="/products" >
//             <div class="toolbar-icon">
//               <BiCategoryAlt />
//             </div>
//             <div class="toolbar-label">Shop</div>
//           </a>
//         </div>
//         <div class="toolbar-item">
//           <a style={{ color: "black" }} href="/SearchBar" >
//             <div class="toolbar-icon">
//               <IoSearchOutline />
//             </div>
//             <div class="toolbar-label">Search</div>
//           </a>
//         </div>
//         <div class="toolbar-item">
//           <a style={{ color: "black" }} href="/cart">
//             <div class="toolbar-icon">
//               <FaShoppingCart />
//             </div>
//             <div class="toolbar-label">Cart</div>
//           </a>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Checkout;



import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { BiCategoryAlt } from "react-icons/bi";
import { IoSearchOutline } from "react-icons/io5";
import { MdOutlineAccountCircle } from "react-icons/md";
import { FaShoppingCart } from "react-icons/fa";
import { IoHome } from "react-icons/io5";

const Checkout = () => {
  const navigate = useNavigate();
  const [cartItems, setCartItems] = useState([]);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    mobile: '',
    flatHouseNo: '',
    landmark: '',
    city: '',
    pinCode: '',
    orderNotes: '',
    aadharNumber: '',
    deliveryType: 'instore'
  });

  const [deliveryCharge, setDeliveryCharge] = useState(0);
  const [isPaymentEnabled, setIsPaymentEnabled] = useState(false);
  const [isAddressEnabled, setIsAddressEnabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [Paymentresponse, setPaymentResponse] = useState(null);

  useEffect(() => {
    const storedCartItems = JSON.parse(localStorage.getItem('cartItems') || '[]');
    setCartItems(storedCartItems);
    
    const phoneNumber = localStorage.getItem('phoneNumber');
    if (phoneNumber) {
      setFormData(prev => ({ ...prev, mobile: phoneNumber }));
    }
  }, []);

  // // Check for payment response once on component mount
  useEffect(() => {
    console.log("🧪 Force checking payment response (bypassing lock)...");
  
    axios
      .get("/api/getpaymentresponse", { withCredentials: true })
      .then((res) => {
        console.log("✅ Payment response received:", res.data);
        
        if (res.data && res.data.easepayid) { 
         

          handlePaymentSuccess(res.data.easepayid);
        }
      })
      .catch((err) => {
        console.error("❌ Error fetching payment response:", err);
      });
  }, []);
  

  // useEffect(() => {
  //   axios
  //     .get("/api/getpaymentresponse", { withCredentials: true })
  //     .then(async (res) => {
  //       console.log("✅ Payment response received:", res.data);
        // const easepayid = res?.data?.easepayid;
  
        // if (!easepayid) return;
  
        // // 🛑 Check if order already exists for this easepayid
        // const checkRes = await axios.get(`/api/orders/check-payment/${easepayid}`);
        // if (checkRes.data.exists) {
        //   console.log("⚠️ Order already placed for this payment ID. Skipping...");
        //   return;
        // }
  
  //       // ✅ No existing order, continue placing
  //       handlePaymentSuccess(easepayid);
  //     })
  //     .catch((err) => {
  //       console.error("❌ Error fetching payment response:", err);
  //     });
  // }, []);
  
  

  const validateForm = () => {
    const newErrors = {};
    
    // Name validation (only alphabets and spaces)
    if (!formData.firstName.trim()) {
      newErrors.firstName = "First Name is required.";
    } else if (!/^[A-Za-z\s]+$/.test(formData.firstName)) {
      newErrors.firstName = "First Name should only contain alphabets.";
    }
  
    if (formData.lastName && !/^[A-Za-z\s]*$/.test(formData.lastName)) {
      newErrors.lastName = "Last Name should only contain alphabets.";
    }
  
    // Aadhar number validation (exactly 12 digits)
    if (!formData.aadharNumber.trim()) {
      newErrors.aadharNumber = "Aadhar Card Number is required.";
    } else if (!/^\d{12}$/.test(formData.aadharNumber)) {
      newErrors.aadharNumber = "Aadhar Card Number must be exactly 12 digits.";
    }
  
    // Email validation
    if (!formData.email.trim()) {
      newErrors.email = "Email ID is required.";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)) {
      newErrors.email = "Please enter a valid email address.";
    }
  
    // Mobile number validation (exactly 10 digits)
    if (!formData.mobile.trim()) {
      newErrors.mobile = "Mobile Number is required.";
    } else if (!/^\d{10}$/.test(formData.mobile)) {
      newErrors.mobile = "Mobile Number must be exactly 10 digits.";
    }
  
    // If delivery type is door delivery, validate address fields
    if (formData.deliveryType === 'doordelivery') {
      if (!formData.flatHouseNo.trim()) {
        newErrors.flatHouseNo = "Flat/House No. is required for door delivery.";
      }
      if (!formData.landmark.trim()) {
        newErrors.landmark = "Landmark is required for door delivery.";
      }
      if (!formData.city.trim()) {
        newErrors.city = "City is required for door delivery.";
      }
      if (!formData.pinCode.trim()) {
        newErrors.pinCode = "Pin Code is required for door delivery.";
      } else if (!/^\d{6}$/.test(formData.pinCode)) {
        newErrors.pinCode = "Pin Code must be exactly 6 digits.";
      }
    }
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
  
    // Update form data
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  
    // Update delivery charge and address fields enablement
    if (name === 'deliveryType') {
      const isDoorDelivery = value === 'doordelivery';
      setDeliveryCharge(isDoorDelivery ? 500 : 0);
      setIsAddressEnabled(isDoorDelivery);
    }
  
    // Clear error for the current field
    setErrors(prev => {
      const newErrors = { ...prev };
      delete newErrors[name];
      return newErrors;
    });
  
    // Perform real-time validation for specific fields
    const fieldValidation = {};
    switch (name) {
      case 'firstName':
        if (value && !/^[A-Za-z\s]+$/.test(value)) {
          fieldValidation[name] = "First Name should only contain alphabets.";
        }
        break;
      case 'lastName':
        if (value && !/^[A-Za-z\s]*$/.test(value)) {
          fieldValidation[name] = "Last Name should only contain alphabets.";
        }
        break;
      case 'aadharNumber':
        if (value && !/^\d*$/.test(value)) {
          fieldValidation[name] = "Aadhar Card Number should only contain digits.";
        } else if (value && value.length === 12 && !/^\d{12}$/.test(value)) {
          fieldValidation[name] = "Aadhar Card Number must be exactly 12 digits.";
        }
        break;
      case 'mobile':
        if (value && !/^\d*$/.test(value)) {
          fieldValidation[name] = "Mobile Number should only contain digits.";
        } else if (value && value.length === 10 && !/^\d{10}$/.test(value)) {
          fieldValidation[name] = "Mobile Number must be exactly 10 digits.";
        }
        break;
      case 'email':
        if (value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
          fieldValidation[name] = "Please enter a valid email address.";
        }
        break;
      case 'pinCode':
        if (value && !/^\d*$/.test(value)) {
          fieldValidation[name] = "Pin Code should only contain digits.";
        } else if (value && value.length === 6 && !/^\d{6}$/.test(value)) {
          fieldValidation[name] = "Pin Code must be exactly 6 digits.";
        }
        break;
    }
  
    setErrors(prev => ({
      ...prev,
      ...fieldValidation
    }));
    
    // Check if all required fields are filled and valid
    validateFields(name, value);
  };
  
  const validateFields = (fieldName, fieldValue) => {
    const requiredFields = ['firstName', 'aadharNumber', 'email', 'mobile'];
    const addressFields = ['flatHouseNo', 'landmark', 'city', 'pinCode'];

    let allFieldsFilled = requiredFields.every(
      (field) => (field === fieldName ? fieldValue?.trim() : formData[field]?.trim()) !== ''
    );

    if (formData.deliveryType === 'doordelivery') {
      allFieldsFilled =
        allFieldsFilled &&
        addressFields.every(
          (field) => (field === fieldName ? fieldValue?.trim() : formData[field]?.trim()) !== ''
        );
    }

    // Only enable payment button if all fields are filled and valid
    setIsPaymentEnabled(allFieldsFilled && Object.keys(errors).length === 0);
  };

  const calculateTotals = () => {
    const cartItems = JSON.parse(localStorage.getItem('cartItems') || '[]');
    const productPrice = cartItems.reduce((total, item) => total + parseFloat(item.salePrice), 0);
    const securityDeposit = productPrice;
    const total = productPrice + securityDeposit + deliveryCharge;

    localStorage.setItem("total1", total);
    
    return {
      productPrice,
      securityDeposit,
      total
    };
  };

  const generateOrderId = () => {
    const timestamp = new Date().getTime();
    const random = Math.floor(Math.random() * 1000);
    return `ORD${timestamp}${random}`;
  };

  const createOrderObject = (orderId, transactionId = null, paymentStatus = "pending", orderStatus = "pending") => {
    const { productPrice, securityDeposit, total } = calculateTotals();
    const cartItems = JSON.parse(localStorage.getItem("cartItems") || "[]");    
    
    return {
      orderId,
      orderDate: new Date().toISOString(),
      customerId: localStorage.getItem("phoneNumber") || "unknown",
      customerDetails: {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        mobile: formData.mobile,
        aadharNumber: formData.aadharNumber,
        deliveryType: formData.deliveryType,
        address: {
          flatHouseNo: formData.flatHouseNo,
          landmark: formData.landmark,
          city: formData.city,
          pinCode: formData.pinCode,
        },
      },
      orderNotes: formData.orderNotes || "",
      products: cartItems.map((item) => ({
        productId: item.id,
        images: item.image,
        duration: item.duration,
        sizeId: item.sizeId,
        name: item.productName,
        price: parseFloat(item.salePrice),
        quantity: item.quantity || 1,
        deliveryDate: item.deliveryDate,
        returnDate: item.returnDate,
      })),
      paymentDetails: {
        productPrice,
        securityDeposit,
        deliveryCharge,
        totalAmount: total,
        paymentId: transactionId,
        status: paymentStatus,
      },
      orderStatus,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    };
  };

  const saveOrderToDatabase = async (orderData) => {
    try {
      const response = await fetch('/api/orders', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(orderData)
      });

      if (!response.ok) {
        throw new Error('Failed to save order');
      }

      return await response.json();
    } catch (error) {
      console.error('Error saving order:', error);
      throw error;
    }
  };

  const handlePaymentSuccess = async (transactionId) => {
    try {
      if (!transactionId) {
        throw new Error('Transaction ID not found. Payment flow disrupted.');
      }
  
      // Prevent duplicate execution
      if (localStorage.getItem('orderPlaced') === 'true') {
        return; // order already handled
      }
  
      const orderId = generateOrderId();
      const paymentStatus = "completed";
      const orderStatus = "confirmed";
      const orderData = createOrderObject(orderId, transactionId, paymentStatus, orderStatus);
  
      const savedOrder = await saveOrderToDatabase(orderData);
      
      // Mark order as placed
      localStorage.setItem('orderPlaced', 'true');
  
      // Clear cart and other items
      localStorage.removeItem('cartItems');
      localStorage.removeItem('transactionId');
      
      navigate('/OrderConfirm', { 
        state: { 
          orderId: savedOrder.orderId, 
          totalAmount: orderData.paymentDetails.totalAmount, 
          transactionId 
        } 
      });
    } catch (error) {
      alert('Failed to save order details. Please contact support.');
      console.error('Order placement error:', error);
    }
  };
  

  const handlePayment = async (e) => {
    e.preventDefault();

    // Check if user is logged in
    const userId = localStorage.getItem('phoneNumber');
    if (!userId) {
      alert('Please login first');
      navigate('/login');
      return;
    }

    // Validate form before proceeding
    if (!validateForm()) {
      return;
    }

    const { total } = calculateTotals();
    const paymentData = {
      amount: total,
      firstname: formData.firstName,
      email: formData.email,
      phone: formData.mobile,
      productinfo: cartItems[0]?.productName || "Product Order",
    };

    try {
      console.log("Sending Payment Request:", paymentData);
      const response = await axios.post("/initiate-payment", paymentData);
      console.log("Payment Response:", response.data);

      if (response.data && response.data.data) {
        window.location.href = `https://pay.easebuzz.in/pay/${response.data.data}`;
      } else {
        console.error("Payment initiation failed");
        alert("Failed to initiate payment. Please try again.");
      }
    } catch (error) {
      console.error("Error initiating payment:", error.message);
      alert("Error initiating payment. Please try again later.");
    }
  };
// In /OrderConfirm page useEffect
useEffect(() => {
  localStorage.removeItem('orderPlaced');
}, []);

  // Remove the handleSubmit function as it's redundant with handlePayment

  const { productPrice, securityDeposit, total } = calculateTotals();

  return (
    <div className="checkout-container">
      <style>
        {`
          .checkout-container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 20px;
          }

          .checkout-wrapper {
            display: flex;
            gap: 30px;
            flex-direction: column;
          }

          @media (min-width: 768px) {
            .checkout-wrapper {
              flex-direction: row;
            }
          }

          .delivery-form {
            flex: 2;
          }

          .price-details {
            flex: 1;
          }

          .form-title {
            font-size: 24px;
            font-weight: bold;
            margin-bottom: 20px;
          }

          .form-grid {
            display: grid;
            grid-template-columns: 1fr;
            gap: 15px;
          }

          @media (min-width: 768px) {
            .form-grid-2 {
              grid-template-columns: 1fr 1fr;
            }
          }

          .form-group {
            margin-bottom: 15px;
          }

          .form-label {
            display: block;
            font-size: 14px;
            font-weight: 500;
            margin-bottom: 5px;
          }

          .form-input {
            width: 100%;
            padding: 8px 12px;
            border: 1px solid #ddd;
            border-radius: 4px;
            font-size: 14px;
          }

          .form-input:focus {
            outline: none;
            border-color: #666;
          }

          .form-input.readonly {
            background-color: #f5f5f5;
          }

          .price-card {
            background-color: #f8f8f8;
            border-radius: 8px;
            padding: 20px;
          }

          .price-title {
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 15px;
          }

          .price-row {
            display: flex;
            justify-content: space-between;
            padding: 10px 0;
            border-bottom: 1px solid #ddd;
          }

          .price-total {
            display: flex;
            justify-content: space-between;
            padding: 15px 0;
            font-weight: bold;
            font-size: 18px;
          }

          .proceed-button {
            width: 100%;
            padding: 12px;
            background-color: #ffc107;
            border: none;
            border-radius: 4px;
            font-weight: 600;
            cursor: pointer;
            margin-top: 15px;
          }

          .proceed-button:disabled {
            background-color: #e0e0e0;
            cursor: not-allowed;
          }

          .proceed-button:hover:not(:disabled) {
            background-color: #ffb300;
          }

          .note-box {
            margin-top: 20px;
            padding: 15px;
            background-color: white;
            border-radius: 4px;
            box-shadow: 0 1px 3px rgba(0,0,0,0.1);
          }

          .note-title {
            font-weight: 600;
            margin-bottom: 8px;
          }

          .note-text {
            font-size: 14px;
            line-height: 1.4;
          }

          .form-textarea {
            width: 100%;
            padding: 8px 12px;
            border: 1px solid #ddd;
            border-radius: 4px;
            min-height: 100px;
            resize: vertical;
          }
          
          .serror-message {
            color: red;
            font-size: 12px;
            margin-top: 4px;
            display: block;
          }
        `}
      </style>
      <div className="checkout-wrapper">
        {/* Left side - Delivery Details Form */}
        <div className="delivery-form">
          <h2 className="form-title">Delivery Details</h2>
          <form>
            <div className="form-grid form-grid-2">
              <div className="form-group">
                <label className="form-label">First Name</label>
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  className="form-input"
                  required
                />
                {errors.firstName && <span className="serror-message">{errors.firstName}</span>}
              </div>
              <div className="form-group">
                <label className="form-label">Last Name</label>
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  className="form-input"
                />
                {errors.lastName && <span className="serror-message">{errors.lastName}</span>}
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">Aadhar Card Number</label>
              <input
                type="tel"
                name="aadharNumber"
                value={formData.aadharNumber}
                onChange={handleInputChange}
                className="form-input"
                placeholder="Enter your 12-digit Aadhar number"
                maxLength="12"
                pattern="\d{12}"
                required
              />
              {errors.aadharNumber && <span className="serror-message">{errors.aadharNumber}</span>}
            </div>

            <div className="form-grid form-grid-2">
              <div className="form-group">
                <label className="form-label">Email ID</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  className="form-input"
                  required
                />
                {errors.email && <span className="serror-message">{errors.email}</span>}
              </div>
              <div className="form-group">
                <label className="form-label">Mobile Number</label>
                <input
                  type="tel"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleInputChange}
                  className="form-input"
                  required
                  maxLength="10"
                />
                {errors.mobile && <span className="serror-message">{errors.mobile}</span>}
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">Delivery Type</label>
              <select
                name="deliveryType"
                value={formData.deliveryType}
                onChange={handleInputChange}
                className="form-input"
                required
              >
                <option value="instore">In-Store Pickup</option>
                <option value="doordelivery">Door Delivery</option>
              </select>
            </div>

            {isAddressEnabled && (
              <>
                <div className="form-group">
                  <label className="form-label">Flat, House no.</label>
                  <input
                    type="text"
                    name="flatHouseNo"
                    value={formData.flatHouseNo}
                    onChange={handleInputChange}
                    className="form-input"
                    placeholder="Flat, House no., Building, Company, Apartment"
                    required
                  />
                  {errors.flatHouseNo && <span className="serror-message">{errors.flatHouseNo}</span>}
                </div>
                <div className="form-group">
                  <label className="form-label">Landmark</label>
                  <input
                    type="text"
                    name="landmark"
                    value={formData.landmark}
                    onChange={handleInputChange}
                    className="form-input"
                    placeholder="Area, Street, Sector, Village"
                    required
                  />
                  {errors.landmark && <span className="serror-message">{errors.landmark}</span>}
                </div>
                <div className="form-grid form-grid-2">
                  <div className="form-group">
                    <label className="form-label">City</label>
                    <input
                      type="text"
                      name="city"
                      value={formData.city}
                      onChange={handleInputChange}
                      className="form-input"
                      required
                    />
                    {errors.city && <span className="serror-message">{errors.city}</span>}
                  </div>
                  <div className="form-group">
                    <label className="form-label">Pincode</label>
                    <input
                      type="text"
                      name="pinCode"
                      value={formData.pinCode}
                      onChange={handleInputChange}
                      className="form-input"
                      required
                      maxLength="6"
                    />
                    {errors.pinCode && <span className="serror-message">{errors.pinCode}</span>}
                  </div>
                </div>
              </>
            )}

            <div className="form-group">
              <label className="form-label">Order Notes (Optional)</label>
              <textarea
                name="orderNotes"
                value={formData.orderNotes}
                onChange={handleInputChange}
                className="form-textarea"
                rows="4"
              />
            </div>
          </form>
        </div>

        {/* Right side - Price Details */}
        <div className="price-details">
          <div className="price-card">
            <h3 className="price-title">Price Details</h3>
            <div className="price-row">
              <span>Products Price</span>
              <span>₹{productPrice.toFixed(2)}</span>
            </div>
            <div className="price-row">
              <span>Refundable Security Deposit</span>
              <span>₹{securityDeposit.toFixed(2)}</span>
            </div>
            <div className="price-row">
              <span>Delivery Charge</span>
              <span>₹{deliveryCharge.toFixed(2)}</span>
            </div>
            <div className="price-total">
              <span>Total Amount</span>
              <span>₹{total.toFixed(2)}</span>
            </div>
            <button
              type="button"
              onClick={handlePayment}
              className="proceed-button"
              disabled={!isPaymentEnabled}
            >
              PROCEED TO PAYMENT
            </button>
          </div>

          <div className="note-box">
            <h4 className="note-title">NOTE</h4>
            <p className="note-text">
              Please visit the nearest showroom in <strong>RoyalHood #29, 1st Floor, BTM 2nd Stage, Bannerghatta Main Road, Opposite To Gopalan Mall, Next Jayadeva Metro Station, Bangalore - 560076 </strong> to
              give fittings for the final booking.
            </p>
          </div>
        </div>
      </div>
      <div className="tf-toolbar-bottom type-1150">
        <div className="toolbar-item">
          <a style={{ color: "black" }} href="/">
            <div className="toolbar-icon">
              <IoHome />
            </div>
            <div className="toolbar-label">Home</div>
          </a>
        </div>
        <div className="toolbar-item">
          <a style={{ color: "black" }} href="/products" >
            <div className="toolbar-icon">
              <BiCategoryAlt />
            </div>
            <div className="toolbar-label">Shop</div>
          </a>
        </div>
        <div className="toolbar-item">
          <a style={{ color: "black" }} href="/SearchBar" >
            <div className="toolbar-icon">
              <IoSearchOutline />
            </div>
            <div className="toolbar-label">Search</div>
          </a>
        </div>
        <div className="toolbar-item">
          <a style={{ color: "black" }} href="/cart">
            <div className="toolbar-icon">
              <FaShoppingCart />
            </div>
            <div className="toolbar-label">Cart</div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Checkout;
